import styled from 'styled-components';
import { addStyleIfPropTruly } from "../../utils/styledComponents";
var Icon = styled.svg.withConfig({
  displayName: "Icon",
  componentId: "sc-1oyaxum-0"
})(["fill:", ";", " ", ""], function (_ref) {
  var color = _ref.color;
  return color || 'currentColor';
}, function (_ref2) {
  var hoverColor = _ref2.hoverColor;
  return hoverColor ? "&:hover { fill: ".concat(hoverColor, ";}") : '';
}, addStyleIfPropTruly('onClick', 'cursor: pointer;'));
export default Icon;